import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { AuthService } from "./auth.service";

// Provisioning of CUSTOMER-PORTAL accounts (the employer-facing self-service
// app at portal.friggkantine.no) from the admin dashboard.
//
// Everything goes through the cloud /portalAdmin endpoints rather than
// AngularFire, because creating a portal account is three coupled writes —
// Firebase Auth user, portalUsers doc, and custom claims — and only the
// server can do the last two. The endpoints are super-admin gated server-side;
// the ID token below is what proves that.
@Injectable({ providedIn: 'root' })
export class PortalAdminService {

    private base = environment.apiUrl + '/widgets/portalAdmin';

    constructor(private http: HttpClient, private auth: AuthService) { }

    private async authOptions() {
        const token = await this.auth.getToken();
        return {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            })
        };
    }

    async listUsers(customerId?: string): Promise<any[]> {
        const opts = await this.authOptions();
        const url = this.base + '/users' + (customerId ? '?customerId=' + encodeURIComponent(customerId) : '');
        const res: any = await this.http.get(url, opts).toPromise();
        return (res && res.users) || [];
    }

    async createUser(payload: { email: string, name: string, role: string, customerIds: string[] }): Promise<any> {
        const opts = await this.authOptions();
        return this.http.post(this.base + '/users', JSON.stringify(payload), opts).toPromise();
    }

    async updateUser(uid: string, patch: any): Promise<any> {
        const opts = await this.authOptions();
        return this.http.patch(this.base + '/users/' + uid, JSON.stringify(patch), opts).toPromise();
    }

    async resendInvite(uid: string): Promise<any> {
        const opts = await this.authOptions();
        return this.http.post(this.base + '/users/' + uid + '/resendInvite', '{}', opts).toPromise();
    }
}
